import LineDividersWithContent from "components/LineDividersWithContent";
import React, { useEffect, useState } from "react";
import "./claimSupport.css"
import { flattenArray, starLineWrapperJsx } from "utlis/utils";

const EscalationJSX = ({ escalationDetailsArray }) => {
    
    const [normalizedFlattenedArray, setNormalizedFlattenedArray] = useState(escalationDetailsArray)
    
    useEffect(() => {
        const updatedArray = flattenArray(escalationDetailsArray)
        setNormalizedFlattenedArray(updatedArray)
    }, [escalationDetailsArray])

    if (escalationDetailsArray && escalationDetailsArray.length === 0) {
        return null
    }

    return (
        <div>

            <div style={{ marginTop: "60px" }}>
                {starLineWrapperJsx(
                    <span className="contact-detail-heading">
                        Escalation Matrix
                    </span>, "28px", "28px"
                )}

                <div style={{ marginTop: "24px"}} className="support-cards-grid">
                    {normalizedFlattenedArray?.map((each_contact, idx) => (
                        <div className="claimSupportCard" key={idx}>

                            <div class="spacing-css">
                                <div>
                                    <span className="maternity-card-heading-css">
                                        {"Level"} {each_contact?.escalation_level}
                                    </span>
                                </div>
                                <div className="gold-line-css" />
                            </div>

                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                marginTop: "16px",
                                gap: "8px"
                            }}>
                                <span className='maternity-max-limit-heading'>
                                    {"Name"}
                                </span>
                                <span className='maternity-max-limit-value'>
                                    {each_contact?.escalation_contact_name}
                                </span>
                            </div>

                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                marginTop: "16px",
                                gap: "8px"
                            }}>
                                <span className='maternity-max-limit-heading'>
                                    {"Mobile Number"}
                                </span>
                                <span className='maternity-max-limit-value'>
                                    {each_contact?.escalation_contact}
                                </span>
                            </div>

                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                marginTop: "16px",
                                gap: "8px"
                            }}>
                                <span className='maternity-max-limit-heading'>
                                    {"Email"}
                                </span>
                                <span className='maternity-max-limit-value'>
                                    {each_contact?.escalation_contact_email}
                                </span>
                            </div>

                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default EscalationJSX;
